<template>
  <div class="container-lg">
    <div class="acciones-panel">
      <button @click="clickExportarTodo()" type="button" class="btn btn-success">
        <span>Exportar todo</span>
        <font-awesome-icon class="icono-derecha" :icon="Icons.DESCARGAR" />
      </button>
      

      <Buscador :esBeneficio="true" :onSearch="filtrarTabla"></Buscador>
    </div>
    <TablaBeneficiosConCodigo
      ref="tablaBeneficiosConCodigo"
      id="tablaBeneficiosConCodigo"
      :comercioList="comercioList"
      :tiposCodigoList="tiposCodigoList"
      :facade="Facade"
    />
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { BeneficioFacade as Facade } from "../../admin/beneficio/beneficio.facade";
import { ComercioFacade } from "../../admin/comercio/comercio.facade";
import { Icons as IconConstants } from "../../constants";
import TablaBeneficiosConCodigo from "./tablas/TablaBeneficiosConCodigo";
import Buscador from "../panel/tablas/util/Buscador.vue"

export default {
  components: {
    FontAwesomeIcon,
    Buscador,
    TablaBeneficiosConCodigo
  },
  props: {
    
  },
  data() {
    return {
      comercioList: undefined,
      tiposCodigoList: undefined
    };
  },
  computed: {
    Facade() {
      return Facade;
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    }
  },
  created() {
    ComercioFacade.getActiveList().then(response => {
      this.comercioList = response.data;
    });
    
    Facade.getTiposCodigo().then(response => {
      this.tiposCodigoList = response.data;
    });

  },
  methods: {
    // TODO: Metodo para exoirtar todo el listado
    clickExportarTodo() {
      Facade.getCsvCodigos(null, null);
    },
    filtrarTabla(busqueda) {
      this.busqueda = busqueda;
      this.$refs.tablaBeneficiosConCodigo.EventoRecargar(busqueda);
    }
  }
};
</script>

<style lang="scss" scoped>
.acciones-panel{
  justify-content: space-between !important;
}
</style>
